import actions from './actions';

const initState = {
	dataMultipleChoiceSingleAnswer: [],
	multipleChoiceSingleAnswerDetail: null,
	totalItems: 0,
	loading: false,
};

export default function multipleChoiceSingleAnswerReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataMultipleChoiceSingleAnswer: res, totalItems, loading: false };

		case actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, multipleChoiceSingleAnswerDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
